import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const TableContainerStyled = styled(Box, {
  width: '100%',
  overflowX: 'auto',
});
